module.exports = __webpack_public_path__ + "img/xiaochengxu_max_remark.ae36c1ba.png";